/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Value1
 */
export interface Value1 {
}

/**
 * Check if a given object implements the Value1 interface.
 */
export function instanceOfValue1(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function Value1FromJSON(json: any): Value1 {
    return Value1FromJSONTyped(json, false);
}

export function Value1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Value1 {
    return json;
}

export function Value1ToJSON(value?: Value1 | null): any {
    return value;
}

